import React, { useState, useEffect } from "react";

const BackupTable = (props) => {
    const { lstBackup, restoreBackup, openSlider, backupId } = props;

    const [lstBackupFiltered, setLstBackupFiltered] = useState([]);
    const [backupFiltered, setBackupFiltered] = useState("");

    useEffect(() => {
        setBackupFiltered("");
        setLstBackupFiltered(lstBackup);
    }, [lstBackup]);

    const handleFilterBackup = (value) => {
        setBackupFiltered(value);
        filterBackupTable(value);
    };

    const filterBackupTable = (filterValue) => {
        let filtered = lstBackup;
        if (filterValue && filterValue.trim() !== "") {
            filtered = filtered.filter(item =>
                item.backup.toLowerCase().includes(filterValue.trim().toLowerCase())
            );
        }
        setLstBackupFiltered(filtered);
    };

    const colgrp = (
        <colgroup>
            <col width="120" />
            <col width="300" />
            <col width="160" />
            <col width="100" />
        </colgroup>
    );

    return (
        <div className="col-md-12 col-xs-12 col-centered padding-remove">
            <table className="tableLayout1">
                {colgrp}
                <thead>
                    <tr>
                        <th>
                            <input
                                type="text"
                                className="form-control inp-search"
                                value={backupFiltered}
                                onChange={e => handleFilterBackup(e.target.value)}
                                placeholder="Backup"
                            />
                        </th>
                        <th>Description</th>
                        <th>Date</th>
                        <th>Action</th>
                    </tr>
                </thead>
            </table>
            <div className="tableDiv" style={{ height: "60vh" }}>
                <table className="tableLayout">
                    {colgrp}
                    <tbody>
                        {lstBackupFiltered && lstBackupFiltered.length > 0 ? (
                            lstBackupFiltered.map((backup) => (
                                <tr
                                    key={backup.backupId}
                                    className={backup.backupId === backupId ? "selected" : ""}
                                    onClick={() => openSlider(backup)}>
                                    <td className="text-left">{backup.backup}</td>
                                    <td className="text-left">{backup.backupNotes}</td>
                                    <td className="text-center">{backup.generationDt}</td>
                                    <td className="text-center">
                                        <span
                                            onClick={() => restoreBackup(backup.backupId)}
                                            title="Edit Teacher Allocation Details"
                                            style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "5px" }}
                                        >
                                            Restore
                                        </span>
                                    </td>
                                </tr>
                            ))
                        ) : null}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default BackupTable;